import type { TenantConfig } from '@/types/TenantConfig'

const darkBlue = '#0F3351'
const blue = '#035D83'
const green = '#098D07'

export const countyofroanoke: TenantConfig = {
  logo: 'assets/countyofroanoke/static/logo.png',
  themeOptions: {
    primaryColor: blue,
    secondaryColor: green,
    footerBackgroundColor: blue,
    footerTextColor: 'white',
    logoHeight: '120px',
    headerHeight: '130px',
    cartHeaderBackgroundColor: darkBlue,
    memberLinksColor: blue,
    memberLinksColorHover: green,
    headerTopBorder: `4px solid ${blue}`,
    headerBottomBorder: '1px solid #EFEFEF',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/countyofroanoke/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-250px',
        mobile: '-200px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: '',
      },
    },
  },
}
